export default {
  // Navigation
  'nav.home': 'Home',
  'nav.solutions': 'Solutions',
  'nav.platform': 'Platform',
  'nav.about': 'About Us',
  'nav.contact': 'Contact',
  'nav.login': 'Client Login',
  
  // Hero Section
  'hero.title': 'Empowering Healthcare Through Intelligent Digital Solutions',
  'hero.subtitle': 'Guangbao-Uni provides comprehensive healthcare management platforms and big data interaction services for medical institutions worldwide, enabling them to deliver superior care to their patients',
  'hero.cta.demo': 'Request Demo',
  'hero.cta.learn': 'Learn More',
  
  // Solutions
  'solutions.title': 'Comprehensive Healthcare Solutions',
  'solutions.subtitle': 'Integrated platforms designed to transform healthcare delivery',
  'solutions.industry.title': 'Industry Application Management Platform',
  'solutions.industry.desc': 'Streamline operations with our comprehensive industry-specific management system designed for healthcare providers',
  'solutions.health.title': 'Integrated Health Platform',
  'solutions.health.desc': 'Unified health management solution connecting medical institutions with patients for seamless care delivery',
  'solutions.enterprise.title': 'Enterprise Management Platform',
  'solutions.enterprise.desc': 'Robust enterprise-grade platform for managing complex healthcare operations and workflows',
  
  // Features
  'features.title': 'Platform Capabilities',
  'features.subtitle': 'Advanced features to enhance healthcare delivery',
  'features.data.title': 'Medical Big Data Analytics',
  'features.data.desc': 'Leverage powerful data analytics to gain insights and improve patient outcomes',
  'features.integration.title': 'Seamless Integration',
  'features.integration.desc': 'Connect with existing systems and third-party services effortlessly',
  'features.security.title': 'Enterprise Security',
  'features.security.desc': 'Bank-level security protocols to protect sensitive medical data',
  'features.scalability.title': 'Global Scalability',
  'features.scalability.desc': 'Cloud infrastructure supporting healthcare institutions worldwide',
  'features.compliance.title': 'Regulatory Compliance',
  'features.compliance.desc': 'Meet international healthcare standards and regulations',
  'features.support.title': '24/7 Support',
  'features.support.desc': 'Round-the-clock technical support for uninterrupted service',
  
  // Benefits
  'benefits.title': 'Why Choose Guangbao-Uni',
  'benefits.subtitle': 'Transform your healthcare institution with our proven solutions',
  'benefits.efficiency.title': 'Improved Efficiency',
  'benefits.efficiency.desc': 'Automate workflows and reduce administrative burden by up to 60%',
  'benefits.patient.title': 'Enhanced Patient Care',
  'benefits.patient.desc': 'Provide better patient experiences through integrated health management',
  'benefits.insights.title': 'Data-Driven Insights',
  'benefits.insights.desc': 'Make informed decisions with comprehensive analytics and reporting',
  'benefits.cost.title': 'Cost Reduction',
  'benefits.cost.desc': 'Optimize resource allocation and reduce operational costs significantly',
  
  // Stats
  'stats.institutions': 'Medical Institutions',
  'stats.countries': 'Countries Served',
  'stats.patients': 'Patients Managed',
  'stats.uptime': 'System Uptime',
  
  // CTA
  'cta.title': 'Ready to Transform Your Healthcare Institution?',
  'cta.subtitle': 'Join leading medical institutions worldwide using Guangbao-Uni platforms',
  'cta.button': 'Get Started Today',
  
  // Footer
  'footer.company': 'Company',
  'footer.about': 'About Us',
  'footer.careers': 'Careers',
  'footer.news': 'News',
  'footer.products': 'Products',
  'footer.industry': 'Industry Platform',
  'footer.health': 'Health Platform',
  'footer.enterprise': 'Enterprise Platform',
  'footer.resources': 'Resources',
  'footer.documentation': 'Documentation',
  'footer.support': 'Support Center',
  'footer.blog': 'Blog',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.security': 'Security',
  'footer.rights': '© 2024 Guangbao-Uni. All rights reserved.',
  'footer.description': 'Leading provider of intelligent healthcare solutions and big data services for medical institutions worldwide.',
  
  // Contact
  'contact.title': 'Get in Touch',
  'contact.subtitle': 'Our team is ready to help you transform your healthcare operations',
  'contact.name': 'Full Name',
  'contact.email': 'Email Address',
  'contact.company': 'Institution Name',
  'contact.phone': 'Phone Number',
  'contact.message': 'Message',
  'contact.submit': 'Send Message',
  'contact.success': 'Thank you! We will contact you soon.',
  
  // Login
  'login.title': 'Client Portal Login',
  'login.subtitle': 'Access your healthcare management platform',
  'login.email': 'Email Address',
  'login.password': 'Password',
  'login.remember': 'Remember me',
  'login.forgot': 'Forgot password?',
  'login.button': 'Sign In',
  'login.support': 'Need help? Contact support',

  // Industry Platform
  'industryPlatform.hero.title': 'Industry Application Management Platform',
  'industryPlatform.hero.subtitle': 'Comprehensive healthcare industry management solution with advanced data analytics, workflow automation, and regulatory compliance capabilities',
  'industryPlatform.hero.exploreFeatures': 'Explore Features',
  'industryPlatform.hero.contactUs': 'Contact Us',
  'industryPlatform.features.title': 'Core Features',
  'industryPlatform.features.subtitle': 'Powerful tools designed for healthcare industry management',
  'industryPlatform.features.dataManagement.title': 'Medical Data Management',
  'industryPlatform.features.dataManagement.desc': 'Centralized medical data storage and management with advanced search and retrieval capabilities',
  'industryPlatform.features.analytics.title': 'Advanced Analytics',
  'industryPlatform.features.analytics.desc': 'Real-time analytics and reporting for data-driven decision making',
  'industryPlatform.features.compliance.title': 'Compliance Management',
  'industryPlatform.features.compliance.desc': 'Ensure adherence to healthcare regulations and industry standards',
  'industryPlatform.features.collaboration.title': 'Multi-Institution Collaboration',
  'industryPlatform.features.collaboration.desc': 'Seamless collaboration tools for healthcare networks and partnerships',
  'industryPlatform.features.customization.title': 'Flexible Customization',
  'industryPlatform.features.customization.desc': 'Tailor the platform to your specific industry requirements',
  'industryPlatform.features.cloudBased.title': 'Cloud Infrastructure',
  'industryPlatform.features.cloudBased.desc': 'Secure, scalable cloud-based architecture for global accessibility',
  'industryPlatform.benefits.title': 'Platform Benefits',
  'industryPlatform.benefits.subtitle': 'Measurable improvements for your healthcare operations',
  'industryPlatform.benefits.efficiency.title': 'Operational Efficiency',
  'industryPlatform.benefits.efficiency.desc': 'Streamline processes and boost productivity across your organization',
  'industryPlatform.benefits.efficiency.label': 'Efficiency Increase',
  'industryPlatform.benefits.accuracy.title': 'Data Accuracy',
  'industryPlatform.benefits.accuracy.desc': 'Minimize errors with automated validation and quality controls',
  'industryPlatform.benefits.accuracy.label': 'Data Accuracy',
  'industryPlatform.benefits.cost.title': 'Cost Savings',
  'industryPlatform.benefits.cost.desc': 'Reduce operational costs through automation and optimization',
  'industryPlatform.benefits.cost.label': 'Cost Reduction',
  'industryPlatform.cta.title': 'Transform Your Healthcare Operations',
  'industryPlatform.cta.subtitle': 'Discover how our platform can revolutionize your industry management',
  'industryPlatform.cta.button': 'Schedule a Demo',

  // Health Platform
  'healthPlatform.hero.title': 'Integrated Health Platform',
  'healthPlatform.hero.subtitle': 'Unified healthcare management solution connecting medical institutions with patients for seamless care delivery and improved health outcomes',
  'healthPlatform.hero.exploreFeatures': 'Explore Features',
  'healthPlatform.hero.contactUs': 'Contact Us',
  'healthPlatform.features.title': 'Platform Features',
  'healthPlatform.features.subtitle': 'Comprehensive tools for integrated health management',
  'healthPlatform.features.patientManagement.title': 'Patient Management',
  'healthPlatform.features.patientManagement.desc': 'Complete patient information management with unified health records',
  'healthPlatform.features.appointment.title': 'Appointment Scheduling',
  'healthPlatform.features.appointment.desc': 'Intelligent scheduling system for efficient appointment management',
  'healthPlatform.features.telemedicine.title': 'Telemedicine Services',
  'healthPlatform.features.telemedicine.desc': 'Remote consultation and virtual care delivery capabilities',
  'healthPlatform.features.ehr.title': 'Electronic Health Records',
  'healthPlatform.features.ehr.desc': 'Secure, comprehensive digital health records accessible anytime',
  'healthPlatform.features.prescription.title': 'E-Prescription',
  'healthPlatform.features.prescription.desc': 'Digital prescription management and pharmacy integration',
  'healthPlatform.features.monitoring.title': 'Health Monitoring',
  'healthPlatform.features.monitoring.desc': 'Continuous patient health monitoring and alerts',
  'healthPlatform.benefits.title': 'Patient Care Benefits',
  'healthPlatform.benefits.subtitle': 'Delivering superior healthcare experiences',
  'healthPlatform.benefits.patientSatisfaction.title': 'Patient Satisfaction',
  'healthPlatform.benefits.patientSatisfaction.desc': 'Enhanced patient experience through seamless care coordination',
  'healthPlatform.benefits.patientSatisfaction.label': 'Satisfaction Rate',
  'healthPlatform.benefits.accessibility.title': 'Healthcare Access',
  'healthPlatform.benefits.accessibility.desc': 'Round-the-clock access to healthcare services and information',
  'healthPlatform.benefits.accessibility.label': 'Availability',
  'healthPlatform.benefits.waitTime.title': 'Reduced Wait Times',
  'healthPlatform.benefits.waitTime.desc': 'Optimized scheduling reduces patient waiting times significantly',
  'healthPlatform.benefits.waitTime.label': 'Time Reduction',
  'healthPlatform.cta.title': 'Elevate Your Patient Care',
  'healthPlatform.cta.subtitle': 'Join healthcare institutions delivering exceptional patient experiences',
  'healthPlatform.cta.button': 'Get Started',

  // Enterprise Platform
  'enterprisePlatform.hero.title': 'Enterprise Management Platform',
  'enterprisePlatform.hero.subtitle': 'Robust enterprise-grade platform for managing complex healthcare operations, workflows, and resources with comprehensive business intelligence',
  'enterprisePlatform.hero.exploreFeatures': 'Explore Features',
  'enterprisePlatform.hero.contactUs': 'Contact Us',
  'enterprisePlatform.features.title': 'Enterprise Features',
  'enterprisePlatform.features.subtitle': 'Complete business management for healthcare enterprises',
  'enterprisePlatform.features.orgManagement.title': 'Organization Management',
  'enterprisePlatform.features.orgManagement.desc': 'Hierarchical organization structure and department management',
  'enterprisePlatform.features.financial.title': 'Financial Management',
  'enterprisePlatform.features.financial.desc': 'Comprehensive financial planning, budgeting, and reporting',
  'enterprisePlatform.features.hr.title': 'Human Resources',
  'enterprisePlatform.features.hr.desc': 'Complete HR management including staffing, scheduling, and performance',
  'enterprisePlatform.features.reporting.title': 'Business Intelligence',
  'enterprisePlatform.features.reporting.desc': 'Advanced reporting and analytics for strategic decision making',
  'enterprisePlatform.features.workflow.title': 'Workflow Automation',
  'enterprisePlatform.features.workflow.desc': 'Automate complex business processes and approval workflows',
  'enterprisePlatform.features.security.title': 'Enterprise Security',
  'enterprisePlatform.features.security.desc': 'Multi-layer security with role-based access control',
  'enterprisePlatform.benefits.title': 'Enterprise Benefits',
  'enterprisePlatform.benefits.subtitle': 'Drive business excellence and growth',
  'enterprisePlatform.benefits.productivity.title': 'Team Productivity',
  'enterprisePlatform.benefits.productivity.desc': 'Empower teams with efficient tools and automated workflows',
  'enterprisePlatform.benefits.productivity.label': 'Productivity Boost',
  'enterprisePlatform.benefits.integration.title': 'System Integration',
  'enterprisePlatform.benefits.integration.desc': 'Connect with existing enterprise systems and third-party services',
  'enterprisePlatform.benefits.integration.label': 'Integrations',
  'enterprisePlatform.benefits.roi.title': 'Return on Investment',
  'enterprisePlatform.benefits.roi.desc': 'Maximize ROI through operational excellence and cost optimization',
  'enterprisePlatform.benefits.roi.label': 'ROI Increase',
  'enterprisePlatform.cta.title': 'Optimize Your Enterprise',
  'enterprisePlatform.cta.subtitle': 'Experience the power of integrated enterprise management',
  'enterprisePlatform.cta.button': 'Request Consultation',
};